export const exchangeRatesStoreKey = 'exchangeRates';
